// removed by extract-text-webpack-plugin
module.exports = {"rulesHolder":"Rules__rulesHolder__3n8Uw"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Rules/Rules.css
// module id = 534
// module chunks = 0